<template>
  <div>
    <el-form ref="formSearch" :inline="true" :model="formData" label-width="100px" label-position="right">
      <el-form-item label="买家账号:">
        <el-input size="small" v-model="formData.pin" placeholder="请输入买家账号" style="margin-right:80px"></el-input>
      </el-form-item>
      <el-form-item label="订单编号:" v-if="permissions.indexOf('hide:order:presellOrder') ==-1 ">
        <el-input
          size="small"
          v-model="formData.orderIdStr"
          @input="formData.orderIdStr = formData.orderIdStr.replace(/，/g, ',')"
          placeholder="请输入订单编号，多个请用','隔开"
          style="margin-right:80px"
        ></el-input>
      </el-form-item>
      <el-form-item label="预售ID:">
        <el-input size="small" v-model="formData.presaleId" placeholder="请输入订单编号" style="margin-right:80px"></el-input>
      </el-form-item>
      <el-form-item label="商品SKU:">
        <inputSKU :sku.sync="formData.skuIds"
          style="margin-right:80px"
        ></inputSKU>
      </el-form-item>

      <el-form-item label="定金实际支付:" class="range-num">
        <el-input
          @input="
            () =>
              (formData.orderPaymentStart = formData.orderPaymentStart
                .replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3')
                .replace(/\.{2,}/g, '.')
                .replace(/[^\d.]/g, ''))
          "
          @change="handleChangeSize(formData.orderPaymentStart, formData.orderPaymentEnd, 'orderPaymentEnd')"
          size="small"
          v-model="formData.orderPaymentStart"
          placeholder="开始"
        ></el-input>
        <span class="to">至</span>
        <el-input
          size="small"
          @input="
            () =>
              (formData.orderPaymentEnd = formData.orderPaymentEnd
                .replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3')
                .replace(/\.{2,}/g, '.')
                .replace(/[^\d.]/g, ''))
          "
          v-model="formData.orderPaymentEnd"
          @change="handleChangeSize(formData.orderPaymentStart, formData.orderPaymentEnd, 'orderPaymentEnd')"
          placeholder="结束"
          style="margin-right:80px"
        ></el-input>
      </el-form-item>
      <el-form-item label="定金实际时间:">
        <div class="my_select_time">
          <el-date-picker
            prefix-icon="no_icon"
            v-model="formData.orderStartTimeStart"
            type="datetime"
            placeholder="选择开始日期时间"
            size="small"
            @change="handleDateSize(formData.orderStartTimeStart, formData.orderStartTimeEnd, 'orderStartTimeEnd')"
            format="yyyy-MM-dd HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm:ss"
            style="width: 120px; font-size:12px"
            :picker-options="pickerOptions0"
            class="time1"
            :clearable="false"
          ></el-date-picker>
          <div class="time_to_text">至</div>
          <el-date-picker
            prefix-icon="no_icon"
            v-model="formData.orderStartTimeEnd"
            type="datetime"
            placeholder="选择结束日期时间"
            size="small"
            @change="handleDateSize(formData.orderStartTimeStart, formData.orderStartTimeEnd, 'orderStartTimeEnd')"
            format="yyyy-MM-dd HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm:ss"
            :picker-options="pickerOptions1"
            style="width: 145px; margin-right:80px;font-size:12px"
            class="time2"
            :clearable="false"
          ></el-date-picker>
          <i
            class="el-icon-circle-close date_icon1"
            @click="(formData.orderStartTimeStart = ''), (formData.orderStartTimeEnd = '')"
            style="margin-right:80px"
          ></i>
          <img src="@/assets/images/select_date.svg" alt class="date_icon2" style="margin-right:80px" />
        </div>
      </el-form-item>
      <el-form-item label="尾款实际支付:" class="range-num">
        <el-input
          size="small"
          @input="
            () =>
              (formData.payBalanceRealMin = formData.payBalanceRealMin
                .replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3')
                .replace(/\.{2,}/g, '.')
                .replace(/[^\d.]/g, ''))
          "
          v-model="formData.payBalanceRealMin"
          @change="handleChangeSize(formData.payBalanceRealMin, formData.payBalanceRealMax, 'payBalanceRealMax')"
          placeholder="开始"
        ></el-input>
        <span class="to">至</span>
        <el-input
          size="small"
          @input="
            () =>
              (formData.payBalanceRealMax = formData.payBalanceRealMax
                .replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3')
                .replace(/\.{2,}/g, '.')
                .replace(/[^\d.]/g, ''))
          "
          v-model="formData.payBalanceRealMax"
          @change="handleChangeSize(formData.payBalanceRealMin, formData.payBalanceRealMax, 'payBalanceRealMax')"
          placeholder="结束"
          style="margin-right:80px"
        ></el-input>
      </el-form-item>
      <el-form-item label="尾款实际时间:">
        <div class="my_select_time">
          <el-date-picker
            prefix-icon="no_icon"
            v-model="formData.balanceTimeStart"
            type="datetime"
            placeholder="选择开始日期时间"
            size="small"
            @change="handleDateSize(formData.balanceTimeStart, formData.balanceTimeEnd, 'balanceTimeEnd')"
            format="yyyy-MM-dd HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm:ss"
            style="width: 120px; font-size:12px"
            :picker-options="pickerOptions2"
            class="time1"
            :clearable="false"
          ></el-date-picker>
          <div class="time_to_text">至</div>
          <el-date-picker
            prefix-icon="no_icon"
            v-model="formData.balanceTimeEnd"
            type="datetime"
            placeholder="选择结束日期时间"
            size="small"
            @change="handleDateSize(formData.balanceTimeStart, formData.balanceTimeEnd, 'balanceTimeEnd')"
            format="yyyy-MM-dd HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm:ss"
            :picker-options="pickerOptions3"
            style="width: 145px; margin-right:80px;font-size:12px"
            class="time2"
            :clearable="false"
          ></el-date-picker>
          <i
            class="el-icon-circle-close date_icon1"
            @click="(formData.balanceTimeStart = ''), (formData.balanceTimeEnd = '')"
            style="margin-right:80px"
          ></i>
          <img src="@/assets/images/select_date.svg" alt class="date_icon2" style="margin-right:80px" />
        </div>
      </el-form-item>
      <el-form-item label="订单状态:" style="margin-right:90px">
        <!-- <el-select v-model="formData.orderState">
          <el-option v-for="(item, index) in orderStatusType" :key="index" :value="item.value" :label="item.label"></el-option>
        </el-select> -->
        <div style="width: 280px">
          <el-button class="search" @click="handleOpen()">已选择{{ checkedStatusType.length }}个</el-button>
        </div>
      </el-form-item>
      <el-form-item label="订单支付类型:" style="margin-right:90px">
        <el-select v-model="formData.orderPayType">
          <el-option value="" label="全部"></el-option>
          <el-option :value="1" label="全款"></el-option>
          <el-option :value="2" label="非全款"></el-option>
        </el-select>
      </el-form-item>

      <!-- <el-form-item label="商品名称:">
        <el-input size="small" v-model="formData.skuName" placeholder="请输入商品名称" style="margin-right:80px"></el-input>
      </el-form-item>
      
      <el-form-item label="省份地区:" style="margin-right:90px">
        <div style="width: 280px">
          <el-button class="search" @click="showCityDialog">已选择{{ checkedList.length }}个</el-button>
        </div>
      </el-form-item> -->
    </el-form>
    <div class="btn_group">
      <el-button size="small" :disabled="tableLoding" class="search" @click="submitForm('formSearch')">
        <i class="el-icon-search" style="display:inline-block;width:14px;height:12px;"></i>
        查询
      </el-button>
      <el-button size="small" class="reset" @click="resetForm">重置</el-button>
    </div>

    <!-- <city-popover v-model="cityShow" :checkedList="checkedList" @on-change="getLocation"></city-popover> -->
    <selectGoodsMonitor
      v-if="goodsState"
      :isShow="goodsState"
      :selectGoods="returnSelectGoods"
      :skuSearch="true"
      @close="selectGoodsChange"
      :moduleType="true"
    />

    <!-- 订单编号 -->
    <el-dialog :visible.sync="addOrderDialog" title="订单状态" width="582px" style="border-bottom-right-radius: 6px">
      <div class="order-line" style="margin-bottom:20px">
        <el-checkbox v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
        <div style="margin: 15px 0;"></div>
        <el-checkbox-group v-model="checkedStatusType" @change="handleCheckedCitiesChange">
          <el-checkbox style="width:33%;margin:7px 0px;" v-for="item in orderStatusType" :label="item.value" :key="item.value">{{
            item.label
          }}</el-checkbox>
        </el-checkbox-group>
      </div>
      <div class="btn-group" style="display: flex;justify-content: end;">
        <el-button class="b1" @click="(addOrderDialog = false), (checkedStatusType = formData.orderState ? formData.orderState.split(',') : [])"
          >取消</el-button
        >
        <el-button class="b2" @click="addEnter()">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import selectGoodsMonitor from "@/components/selectGoodsMonitor2.vue";
import cityPopover from "@/components/city-popover-x.vue";
import inputSKU from "@/components/Form/inputSKU.vue";

export default {
  name: "input_form",
  props: {
    orderStatusType: {
      type: Array,
      default: () => [],
    },
  },
  components: {
    cityPopover,
    selectGoodsMonitor,
    inputSKU
  },
  computed:{
    permissions() {
      // 是否为自营店铺
      return this.$store.getters.loginUserInfo.permissions;
    }
  },
  data() {
    return {
      addOrderDialog: false,
      checkAll: false,
      checkedStatusType: [],
      // isIndeterminate: false,
      goodsState: false,
      returnSelectGoods: [],
      skuGoods: [],
      wareGoods: [],
      skuSearch: false, // 是否为sku搜索
      pickerOptions0: {
        disabledDate: (time) => {
          if (this.formData.orderStartTimeEnd) {
            return time.getTime() > new Date(this.formData.orderStartTimeEnd).getTime();
          }
        },
      },
      pickerOptions1: {
        disabledDate: (time) => {
          if (this.formData.orderStartTimeStart) {
            return time.getTime() < new Date(this.formData.orderStartTimeStart).getTime();
          }
        },
      },
      pickerOptions2: {
        disabledDate: (time) => {
          if (this.formData.balanceTimeEnd) {
            return time.getTime() > new Date(this.formData.balanceTimeEnd).getTime();
          }
        },
      },
      pickerOptions3: {
        disabledDate: (time) => {
          if (this.formData.balanceTimeStart) {
            return time.getTime() < new Date(this.formData.balanceTimeStart).getTime();
          }
        },
      },
      formData: {
        pin: "", // 空
        orderIdStr: "", // 空
        presaleId: "",
        orderPaymentStart: "",
        orderPaymentEnd: "",
        orderPaymentEnd: "",
        payBalanceRealMin: "",
        payBalanceRealMax: "",
        orderStartTimeStart: this.getDateStr(-30) + " 00:00:00",
        orderStartTimeEnd: this.getDateStr(0) + " 00:00:00",
        balanceTimeStart: "",
        balanceTimeEnd: "",
        orderState: "",
        skuIds: "",
        orderPayType: "",
      },
      // orderStatusType: [
      //   {
      //     label: '等待出库',
      //     value: 'WAIT_SELLER_STOCK_OUT'
      //   },
      //   {
      //     label: '发往配送中心（只适用于LBP，SOPL商家）',
      //     value: 'SEND_TO_DISTRIBUTION_CENER'
      //   },
      //   {
      //     label: '配送中心已收货（只适用于LBP，SOPL商家）',
      //     value: 'DISTRIBUTION_CENTER_RECEIVED'
      //   },
      //   {
      //     label: '等待确认收货',
      //     value: 'WAIT_GOODS_RECEIVE_CONFIRM'
      //   },
      //   {
      //     label: '收款确认（服务完成）（只适用于LBP，SOPL商家）',
      //     value: 'RECEIPTS_CONFIRM'
      //   },
      //   {
      //     label: '等待发货（只适用于海外购商家，等待境内发货 标签下的订单）',
      //     value: 'WAIT_SELLER_DELIVERY'
      //   },
      //   {
      //     label: '完成',
      //     value: 'FINISHED_L'
      //   },
      //   {
      //     label: '取消',
      //     value: 'TRADE_CANCELED '
      //   },
      //   {
      //     label: '已锁定',
      //     value: 'LOCKED'
      //   }
      // ],
      payTypeList: [
        {
          label: "货到付款",
          value: 1,
        },
        {
          label: "邮局汇款",
          value: 2,
        },
        {
          label: "自提",
          value: 3,
        },
        {
          label: "在线支付",
          value: 4,
        },
        {
          label: "公司转账",
          value: 5,
        },
        {
          label: "银行转账",
          value: 6,
        },
      ],
      tableLoding: false,
      // checkedList: [],
      // cityShow: false,
      mytimestart: "",
      mytimeend: "",
    };
  },
  mounted() {
    // this.time();
    this.$emit("onSerach", this.formData);
    
  },
  methods: {
    handleChangeSize(num1, num2, name) {
      if (num1 && num2) {
        if (Number(num2) <= Number(num1)) return (this.formData[`${name}`] = "");
      }
    },
    handleDateSize(date1, date2, name) {
      let oDate1 = new Date(date1);
      let oDate2 = new Date(date2);
      if (date1 && date2) {
        if (oDate1.getTime() >= oDate2.getTime()) return (this.formData[`${name}`] = "");
      }
    },
    handleOpen() {
      this.addOrderDialog = true;
      this.checkAll = this.formData.orderState.split(",").length === this.orderStatusType.length;
      this.checkedStatusType = this.formData.orderState ? this.formData.orderState.split(",") : [];
    },
    handleCheckAllChange(val) {
      if (val) {
        this.checkedStatusType = this.orderStatusType.map((item) => item.value);
      } else {
        this.checkedStatusType = [];
      }
      // this.isIndeterminate = false;
    },
    handleCheckedCitiesChange(value) {
      // let checkedCount = value.length;
      this.checkAll = value.length === this.orderStatusType.length;
      // this.isIndeterminate = checkedCount > 0 && checkedCount < this.orderStatusType.length;
    },
    addEnter() {
      this.formData.orderState = this.checkedStatusType.join(",");
      this.addOrderDialog = false;
    },
    // getLocation(val, state) {
    //   if (state == "cancel") {
    //     return;
    //   }
    //   this.checkedList = val;
    // },
    //           time() {
    // let yy = new Date().getFullYear(); //当前年份
    // let mm =
    //   new Date().getMonth() + 1 < 10
    //     ? "0" + (new Date().getMonth() + 1)
    //     : new Date().getMonth() + 1;
    // let dd =
    //   new Date().getDate() < 10
    //     ? "0" + new Date().getDate()
    //     : new Date().getDate(); //当前天数
    // this.mytimestart = `${yy}-${mm}-${dd} 00:00:00`;
    // this.mytimeend = `${yy}-${mm}-${dd} 23:59:59`;
    // this.formData= {
    //   orderStartTimeStart: this.mytimestart, //提交时间开始
    //   orderStartTimeEnd: this.mytimeend, //提交时间结束
    //   sendStartTimeStart: this.mytimestart, //发送时间开始
    //   sendStartTimeEnd: this.mytimeend, //发送时间结束
    // }
    // },
    // 商品组件回调
    selectGoodsChange(val) {
      this.goodsState = false;
      if (val !== false) {
        // this.returnSelectGoods = val;
        var dataList = [];
        var skuList = [];
        val.forEach((item) => {
          dataList.push(item.wareId);
          skuList.push(item.skuId);
        });
        if (!this.skuSearch) {
          // 商品id
          this.wareGoods = val;
          // this.formData.wareIds = dataList.join(",");
        } else {
          // sku id
          this.skuGoods = val;
          this.formData.skuIds = skuList.join(",");
        }
      }
    },
    // focus() {
    //   this.skuSearch = false;
    //   this.returnSelectGoods = this.wareGoods;
    //   this.goodsState = true;
    // },
    // focusSku() {
    //   this.skuSearch = true;
    //   this.returnSelectGoods = this.skuGoods;
    //   this.goodsState = true;
    // },
    // showCityDialog() {
    //   this.cityShow = true;
    // },
    clearTimeSendTime() {
      this.formData.orderStartTimeStart = "";
      this.formData.orderStartTimeEnd = "";
    },
    submitForm() {
      console.log("111111111");
      // this.formData.province = this.checkedList.join(",");
      // this.formData.cites = this.checkedList.join(",");
      this.$emit("onSerach", this.formData);
    },
    resetForm() {
      this.formData = {
        pin: "", // 空
        orderIdStr: "", // 空
        presaleId: "",
        orderPaymentStart: "",
        orderPaymentEnd: "",
        orderPaymentEnd: "",
        payBalanceRealMin: "",
        payBalanceRealMax: "",
        orderStartTimeStart: this.getDateStr(-30) + " 00:00:00",
        orderStartTimeEnd: this.getDateStr(0) + " 00:00:00",
        balanceTimeStart: "",
        balanceTimeEnd: "",
        orderState: "",
        skuIds: "",
        orderPayType: "",
      };
      this.checkAll = false;
      this.checkedStatusType = [];
      // this.checkedList = [];
      console.log("2222222");
      this.$emit("onSerach", this.formData);
    },
  },
};
</script>

<style lang="scss" scoped>
/** 弹窗相关样式 */
.btn-group {
  text-align: right;
  margin-top: 20px;
  .el-button {
    width: 98px;
  }
  .b1 {
    width: 98px;
    height: 32px;
    color: #999999;
    border-radius: 3px;
    border: 1px solid #cccccc;
    background-color: #fff;
    &:hover {
      color: #fe4d45;
      border: 1px solid #fe4d45;
      background-color: #fff4f4;
    }
    &:active {
      color: #fe4d45;
      border: 1px solid #fe4d45;
      background-color: #fff4f4;
    }
  }
  .b2 {
    width: 98px;
    height: 32px;
    color: #ffffff;
    border-radius: 3px;
    border: 1px solid #fe4d45;
    background-color: #fe4d45;
    &:hover {
      color: #fff;
      opacity: 0.9;
      background-color: #fe4d45;
    }
    &:active {
      color: #fe4d45;
      border: 1px solid #fe4d45;
      background-color: #fff4f4;
    }
  }
}
.el-input,
.el-select {
  width: 280px;
}
.range-num {
  .el-input {
    width: 125px;
  }
  .to {
    padding: 0 8px;
  }
}
.search {
  color: rgb(254, 77, 69);
  background-color: #ffffff;
  border-radius: 3px;
  border: 1px solid rgb(254, 77, 69);
  font-size: 14px;
}
.search:hover {
  color: #ffffff;
  background-color: rgb(254, 77, 69);
}
.reset {
  width: 98px;
  height: 32px;
  font-size: 14px;
  border-radius: 3px;
  color: #666666;
  border: 1px solid #dddddd;
  background-color: #fff;
  &:hover {
    color: #fe4d45;
    border: 1px solid #fe4d45;
    background-color: #fff4f4;
  }
}
.select-input-type {
  .el-select {
    width: 136px;
    margin-right: 8px;
  }
  .el-input {
    width: 136px;
  }
}
.btn_group {
  text-align: center;
  .search {
    color: rgb(254, 77, 69);
    background-color: #ffffff;
    border: 1px solid rgb(254, 77, 69);
    font-size: 14px;
  }
  .search:hover {
    color: #ffffff;
    background-color: rgb(254, 77, 69);
  }
}
</style>
